export default "__VITE_ASSET__BDMGazaA__"